import request from "@/services/request";
export function selectFromById(params) {
    return request({
        url: '/jput/form/selectFromById',
        method: 'get',
        params
    })
}
export function saveOrUpdateForms(data) {
    return request({
        url: '/jput/form/saveOrUpdateForms',
        method: 'post',
        data: JSON.stringify(data),
    })
}
export function pilotSaveOrUpdateTimesheet(data) {
    return request({
        url: '/jput/form/pilot/saveOrUpdateTimesheet',
        method: 'post',
        data: JSON.stringify(data),
    })
}
export function pilotReportEquipment(params) {
    return request({
        url: '/jput/form/pilot/reportEquipment',
        method: 'get',
        params
    })
}
export function pilotSaveReportEquipment(data) {
    return request({
        url: '/jput/form/pilot/saveReportEquipment',
        method: 'post',
        data: JSON.stringify(data),
    })
}
export function getEquipmentReports(params) {
    return request({
        url: '/jput/form/pilot/getReportEquipmentList',
        method: 'get',
        params
    })
}
export function pilotResolveReportEquipment(data) {
    return request({
        url: '/jput/form/pilot/resolveReportEquipment',
        method: 'post',
        data: JSON.stringify(data),
    })
}
export function getPilotList(params) {
    return request({
        url: '/jput/pilot/getPilotsInfo',
        method: 'get',
        params
    })
}
export function savePilot(data) {
    return request({
        url: '/jput/pilot/savePilot',
        method: 'post',
        data: JSON.stringify(data),
    })
}
export function deletePilot(id) {
    return request({
        url: '/jput/pilot/deletePilot/' + id,
        method: 'put',
    })
}
export function getTugBoatList(params) {
    return request({
        url: '/jput/pilot/getTugBoatsInfo',
        method: 'get',
        params
    })
}
export function saveTugBoat(data) {
    return request({
        url: '/jput/pilot/saveTugBoat',
        method: 'post',
        data: JSON.stringify(data),
    })
}
export function deleteTugBoat(id) {
    return request({
        url: '/jput/pilot/deleteTugBoat/' + id,
        method: 'put',
    })
}
export function getFormTugBoat(params) {
    return request({
        url: '/jput/form/pilot/tugBoat',
        method: 'get',
        params
    })
}
export function saveFormTugBoat(data) {
    return request({
        url: '/jput/form/pilot/saveTugBoat',
        method: 'post',
        data: JSON.stringify(data),
    })
}
export function savePilotRemarks(data) {
    return request({
        url: '/jput/pilot/savePilotRemarks',
        method: 'post',
        data: JSON.stringify(data),
    })
}
export function signForm(data) {
    return request({
        url: '/jput/form/signForm',
        method: 'post',
        data
    })

}
export function getSystemEmail(params) {
    return request({
        url: '/sysEmail/list',
        method: 'get',
        params
    })
}
export function saveSystemEmail(data) {
    return request({
        url: '/sysEmail/save',
        method: 'post',
        data: JSON.stringify(data),
    })
}
export function removeSystemEmail(id) {
    return request({
        url: '/sysEmail/remove/' + id,
        method: 'delete',
    })
}
export function getMaintenanceDetails(params) {
    return request({
        url: '/sysSetting/getMaintenanceDetails',
        method: 'get',
        params
    })
}
export function sendScheduledEmail(data) {
    return request({
        url: '/sysEmail/sendScheduledEmail',
        method: 'post',
        data
    })
}
export function getLatestHoseReading(params) {
    return request({
        url: '/jput/form/checkHose',
        method: 'get',
        params
    })
}
export function getDashboardNominationCompleted(params) {
    return request({
        url: '/jput/nomination/dashboard/completedNominations',
        method: 'get',
        params
    })
}
export function getDashboardTotalQuantityLoaded(params) {
    return request({
        url: '/jput/nomination/dashboard/loadedData',
        method: 'get',
        params
    })
}
export function getDashboardLiftedProductBreakdown(params) {
    return request({
        url: '/jput/nomination/dashboard/whiteBlackOil',
        method: 'get',
        params
    })
}
export function downloadAfterLoadingFormsPdf(data) {
    return request({
        url: `/jput/form/generateAfterLoadingPdf?nominationId=${data.nominationId}`,
        method: "post",
        responseType: "blob",
        //   data,
    });
}

export function saveOrUpdateHighVarianceReport(data) {
    return request({
        url: '/jput/form/saveOrUpdateHighVarianceReport',
        method: 'post',
        data: JSON.stringify(data),
    });
}

export function getHighVarianceReport(params) {
    return request({
        url: '/jput/form/getHighVarianceReport',
        method: 'get',
        params,
    });
}

export function getHighVarianceNominations(params = {}) {
    return request({
        url: "/jput/nomination/highVarianceNomList",
        method: "get",
        params
    });
}

export function vesselSaveOrUpdateForms(data) {
    return request({
        url: '/jput/form/saveOrUpdateFormsVesselNom',
        method: 'post',
        data: JSON.stringify(data),
    })
}

export function signVesselForm(data) {
    return request({
        url: '/jput/form/signFormVesselNom',
        method: 'post',
        data
    })
}

export function createHoldingCert(data) {
    return request({
        url: '/holdingCert/create',
        method: 'post',
        data
    })
}

export function uploadHoldingCertFile(id, files = [], deleteIds = []) {
    const formData = new FormData();

    formData.append("id", id);

    if (deleteIds && deleteIds.length > 0) {
        formData.append("deletedIds", deleteIds.join(","));
    }

    if (files && files.length > 0) {
        files.forEach((file) => {
            formData.append("files", file);
        });
    }
    return request({
        url: "/holdingCert/uploadFiles",
        method: "post",
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
    });
}


export function getHoldingCertDetail(params) {
    return request({
        url: '/holdingCert/details',
        method: 'get',
        params
    })
}

export function updateHoldingCert(data) {
    return request({
        url: '/holdingCert/modify',
        method: 'post',
        data
    })
}

export function generateHoldingCertPdf(id) {
    return request({
        url: '/holdingCert/generatePdf?id=' + id,
        method: 'post',
        responseType: 'blob',
    })
}
export function signHoldingCert(data) {
    return request({
        url: '/holdingCert/sign',
        method: 'post',
        data
    })
}

export function invalidateHoldingCert(id) {
    return request({
        url: '/holdingCert/invalidate?certId=' + id,
        method: 'post',
    })
}

export function getTankBookStockList(params) {
    return request({
        url: '/bookStock/list',
        method: 'get',
        params
    })
}

export function getTankBookDetail(id) {
    return request({
        url: '/bookStock/' + id,
        method: 'get',
    })
}

export function getTransactionRecord(id,params) {
    return request({
        url: '/bookStock/transaction/list/' + id,
        method: 'get',
        params
    })
}

export function createNewTransaction(data) {
    return request({
        url: '/bookStock/create',
        method: 'post',
        data
    })
}
export function modifyTransaction(id, data) {
    return request({
        url: '/bookStock/modify/' + id,
        method: 'put',
        data
    })
}

export function exportExcel(params) {
    return request({
        url: '/bookStock/export',
        method: 'get',
        params,
        responseType: 'blob', 
    })
}

export function exportTransactionExcel(params) {
    return request({
        url: '/bookStock/transaction/export',
        method: 'get',
        params,
        responseType: 'blob', 
    })
}

export function createNewTransactionRecord(data) {
    return request({
        url: '/bookStock/transaction/create',
        method: 'post',
        data
    })
}

export function modifyTransactionRecord(id, data) {
    return request({
        url: '/bookStock/transaction/modify/' + id,
        method: 'put',
        data
    })
}

export function deleteTransactionRecord(id) {
    return request({
        url: '/bookStock/transaction/delete/' + id,
        method: 'delete',
    })
}

export function updateProduct(data) {
    return request({
        url: '/jptt/productList/update',
        method: 'put',
        data,
    })
}

export function deleteProduct(id) {
    return request({
        url: '/jptt/productList/' + id,
        method: 'delete',
    })
}

export function addProductM(data) {
    return request({
        url: '/jptt/productList/add',
        method: 'post',
        data,
    })
}

export function getTankBookStockHistory(params) {
    return request({
        url: '/bookStock/history/list',
        method: 'get',
        params
    })
}
